import {
  Card,
  Chip,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import Link from 'next/link';
import { useEffect } from 'react';
import { ItemAPI } from '../../api/item';
import { useNotificationContext } from '../shared/notification';
import {
  colors,
  CompactTableCell,
  CompactTableRow,
} from '../shared/ui-extension';

export const InventoryImpactDialog = ({
  pendingTransactions,
  handleConfirm,
  handleCancel,
  onClose,
  title = 'The following orders will be impacted. Continue?',
}) => {
  const { handleException, openDialog } = useNotificationContext();

  useEffect(() => {
    const showPendingInventoryImpact = async (pendingTransactions) => {
      const impacts = await checkPotentialInventoryImpact(pendingTransactions);

      if (impacts.length > 0) {
        openDialog({
          title: <Typography variant='body'>{title}</Typography>,
          content: (
            <Card sx={{ padding: 0 }}>
              <TableContainer>
                <Table size='small'>
                  <TableHead>
                    <TableRow>
                      <CompactTableCell>Order Number/Line</CompactTableCell>
                      <CompactTableCell>Pending Changes</CompactTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {impacts.map((ip, i) => {
                      return (
                        <CompactTableRow
                          key={i}
                          sx={
                            ip.isImpactSource
                              ? {
                                  backgroundColor: colors.rowHighlight,
                                }
                              : undefined
                          }
                        >
                          <CompactTableCell>
                            <Link
                              href={`/order-entry?orderNo=${ip.transactionReferenceNumber}`}
                              target='_blank'
                              rel='noreferrer'
                              style={{
                                textDecoration: 'underline',
                                cursor: 'pointer',
                              }}
                              title={`View SO# ${ip.transactionReferenceNumber} details in a new window`}
                            >
                              {ip.transactionReferenceId}
                            </Link>
                            {ip.isImpactSource ? (
                              <Chip
                                label='this Order'
                                size='small'
                                color='primary'
                                sx={{ marginLeft: 1 }}
                              />
                            ) : null}
                          </CompactTableCell>
                          <CompactTableCell>{ip.reason}</CompactTableCell>
                        </CompactTableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>
          ),
          handleConfirm: handleConfirm,
          handleCancel: handleCancel,
          onClose: onClose,
        });
      } else {
        handleConfirm && handleConfirm();
      }
    };

    if (pendingTransactions && pendingTransactions.length > 0) {
      showPendingInventoryImpact(pendingTransactions);
    }
  }, [pendingTransactions]);

  const checkPotentialInventoryImpact = async (pendingTransactions) => {
    try {
      const { data: impacts } = await ItemAPI.checkInventoryImpact(
        pendingTransactions
      );
      return impacts;
    } catch (e) {
      handleException(e);
      return [];
    }
  };

  return <></>;
};

export const getDefaultInventoryImpactDialog = () => ({
  pendingTransactions: [],
  handleConfirm: null,
  handleCancel: null,
  onClose: null,
});
